import { FC } from 'react';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import { IProductForAverageReviews } from 'commerce/services/reviews/types';
import { ListicleTile } from './ListicleTile';
import styles from './styles.module.css';

export const ListicleProducts: FC<{
  products?: IProductForAverageReviews[];
}> = ({ products }) => {
  return (
    <div className={styles.wrapper}>
      {products?.map((product, index) => (
        <ListicleTile
          key={product.referenceKey}
          bapiProduct={product as IAdaptedProduct}
          index={index}
        />
      ))}
    </div>
  );
};
